import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/seo";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <Logo markSize={44} />
        {sent ? (
          <div className="mt-8 text-center" data-testid="forgot-success">
            <MailCheck className="h-12 w-12 text-emerald-400 mx-auto mb-4" />
            <h1 className="font-display text-xl font-bold text-foreground">Check your email</h1>
            <p className="text-sm text-muted-foreground mt-2">If that email is registered, a reset link has been sent.</p>
            <Button asChild variant="outline" className="mt-6 border-border"><Link to="/login">Back to sign in</Link></Button>
          </div>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold text-foreground mt-8">Reset password</h1>
            <p className="text-sm text-muted-foreground mt-1">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <Label className="text-xs text-muted-foreground">Email</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1.5 bg-secondary/50 border-border" />
              </div>
              {error && <p className="text-sm text-red-400">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-primary text-white font-semibold rounded-full h-11">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "SEND RESET LINK"}
              </Button>
            </form>
            <Link to="/login" className="mt-4 block text-sm text-muted-foreground hover:text-primary">← Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
